import React, { useState, useEffect } from "react";
import Button from "./Button";
import "./Navbar.css";

export default function Navbar({ scrollToContacts }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll("section");
      let currentSection = "home";

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;

        if (window.scrollY >= sectionTop - sectionHeight / 3) {
          currentSection = section.getAttribute("id");
        }
      });

      setActiveLink(currentSection);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="logo">Emmanuel Kipngetich</div>

      <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
        <i className={menuOpen ? "fas fa-times" : "fas fa-bars"}></i>
      </div>

      <div className={`nav-links ${menuOpen ? "active" : ""}`}>
        {["home", "projects", "experience", "education", "workshops"].map((link) => (
          <a
            key={link}
            href={`#${link}`}
            className={activeLink === link ? "active" : ""}
            onClick={handleLinkClick}
          >
            {link.charAt(0).toUpperCase() + link.slice(1)}
          </a>
        ))}

        <div className="contact-button-mobile">
          <Button
            text="Contact Me"
            onClick={() => {
              scrollToContacts();
              setMenuOpen(false);
            }}
          />
        </div>
      </div>

      <div className="contact-button-desktop">
        <Button text="Contact Me" onClick={scrollToContacts} />
      </div>
    </nav>
  );
}
